import { withIcon } from './withIcon';

const EditSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M15.8959 4.90229C15.7979 3.92189 15.2096 3.03954 14.4253 2.45131C13.739 1.96111 12.9547 1.66699 12.1704 1.66699C10.9939 1.66699 9.91551 2.15719 9.22924 3.13758L2.56257 11.9611C0.601786 14.6082 2.36649 17.7454 2.46453 17.8435C2.56257 18.0395 2.75865 18.1376 2.95473 18.2356C2.95473 18.2356 3.54296 18.3337 4.32728 18.3337C5.60179 18.3337 7.36649 18.0395 8.54296 16.3729L13.8371 9.31405L15.1116 7.64738C15.7979 6.86307 16.092 5.88268 15.8959 4.90229ZM7.36649 15.4905C6.28806 16.9611 4.32728 16.8631 3.54296 16.765C3.24885 16.0788 2.66061 14.3141 3.73904 12.7454L8.641 6.1768L12.2685 8.92189L7.36649 15.4905ZM14.0332 6.76503L13.1508 7.84346L9.6214 5.09836L10.5037 4.01993C11.2881 3.03954 12.6606 2.84346 13.641 3.52974C14.1312 3.92189 14.4253 4.41209 14.5234 5.00033C14.5234 5.6866 14.4253 6.27483 14.0332 6.76503ZM17.5626 16.667H11.2881C10.8959 16.667 10.5037 16.9611 10.5037 17.4513C10.5037 17.8435 10.7979 18.2356 11.2881 18.2356H17.5626C17.9547 18.2356 18.3469 17.9415 18.3469 17.4513C18.3469 16.9611 18.0528 16.667 17.5626 16.667Z"
      fill="currentColor"
    />
  </svg>
);

export const Edit = withIcon(EditSvg);
